import React from 'react';

import cx from 'classnames';
import {useDroppable} from '@dnd-kit/core';

interface DividerProps {
  id: string;
  isVisible: boolean;
  isHovered: boolean;
  onClick: () => void;
}

export const Divider = ({id, isVisible, isHovered, onClick}: DividerProps) => {
  const {isOver, setNodeRef} = useDroppable({id});

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isVisible) {
      onClick();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (isVisible) {
        onClick();
      }
    }
  };

  return (
    <div
      ref={setNodeRef}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role='button'
      tabIndex={isVisible ? 0 : -1}
      aria-label='Insert position'
      aria-hidden={!isVisible}
      className={cx(
        'group flex w-(--control-target-min-size) shrink-0 items-center justify-center self-stretch',
        {
          'cursor-pointer': isVisible,
          'pointer-events-none cursor-default': !isVisible
        }
      )}
    >
      <div
        className={cx('h-full w-px rounded-full transition-opacity', {
          'opacity-0': !isVisible,
          'opacity-100': isVisible,
          'border border-dashed border-bold group-hover:border-solid group-hover:border-brand':
            isVisible && !isOver && !isHovered,
          'border border-solid border-brand': isVisible && (isOver || isHovered)
        })}
      />
    </div>
  );
};

export default Divider;
